/** True when APP_ENV is dev or development (local / dev deploy only). */
export function isAppDevEnvironment(): boolean {
	if (typeof document !== "undefined") {
		const meta = document
			.querySelector('meta[name="app-env"]')
			?.getAttribute("content")
			?.trim()
			.toLowerCase();
		if (meta) {
			return meta === "dev" || meta === "development";
		}
	}

	const baked = (process.env.APP_ENV as string | undefined)?.trim().toLowerCase();
	if (baked) {
		return baked === "dev" || baked === "development";
	}

	return false;
}
